var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SectionHeader", {
    attrs: {
      "show-content": _vm.customScoringSettingsShowContents,
      "widget-title": _vm.$t("HEADER_CUSTOM_SCORING_SETTINGS")
    },
    on: {
      onShowContentsClick: function($event) {
        return _vm.onCustomScoringSettingsShowContentsClick()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "form-horizontal" },
              [
                _c("Field", {
                  attrs: {
                    label: _vm.$t("LABEL_CUSTOM_SCORING_TOGGLE"),
                    "hide-label": false,
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t("LABEL_CUSTOM_SCORING_TOGGLE_TT")
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "element",
                      fn: function() {
                        return [
                          _vm.hasCustomScoringV1
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-12 col-sm-9 col-md-8 col-lg-6"
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "bs-callout bs-callout-sm bs-callout-warning m-t-5",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("MESSAGE_CUSTOM_SCORING_V1")
                                      )
                                    }
                                  })
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "col-sm-6 col-md-6" },
                                [
                                  _c(
                                    "ValidationProvider",
                                    { attrs: { slim: "" } },
                                    [
                                      _c("MultipleToggle", {
                                        attrs: {
                                          value: _vm.customScoring.state,
                                          options:
                                            _vm.customScoringSettingOptions
                                        },
                                        on: {
                                          onToggle: function($event) {
                                            return _vm.customScoringSettingChange(
                                              $event
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _vm.customScoring.state === "On" ||
                _vm.customScoring.state === "Required"
                  ? [
                      _c("Field", {
                        attrs: {
                          label: _vm.$t("LABEL_CUSTOM_SCORING_URL"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("LABEL_CUSTOM_SCORING_URL_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c("ValidationProvider", {
                                    ref: "customScoringUrl",
                                    attrs: { rules: "required|url", slim: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ classes }) {
                                            return [
                                              _c("div", { class: classes }, [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-xs-10 col-sm-6"
                                                  },
                                                  [
                                                    _c("HttpUrl", {
                                                      attrs: {
                                                        name: "customScoringUrl"
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.updateCustomScoringSettings
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.customScoring
                                                            .scoreSettingsV2
                                                            .url,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.customScoring
                                                              .scoreSettingsV2,
                                                            "url",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "customScoring.scoreSettingsV2.url"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("label", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value: "REQUIRED",
                                                      expression: "'REQUIRED'"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "col-xs-2 col-sm-3 form-group__label-required"
                                                })
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      788208878
                                    )
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2008322581
                        )
                      }),
                      _vm._v(" "),
                      _c("Field", {
                        attrs: {
                          label: _vm.$t("LABEL_CUSTOM_SCORING_METHOD"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t(
                            "LABEL_CUSTOM_SCORING_METHOD_TT"
                          )
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-xs-10 col-sm-3 col-md-2"
                                    },
                                    [
                                      _c("HttpMethodSelector", {
                                        attrs: {
                                          name: "customScoringConnectionMethod",
                                          "custom-options":
                                            _vm.httpConnectionOptions
                                        },
                                        on: {
                                          input:
                                            _vm.onCustomScoringConnectionMethodChange
                                        },
                                        model: {
                                          value:
                                            _vm.customScoring.scoreSettingsV2
                                              .method,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.customScoring.scoreSettingsV2,
                                              "method",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "customScoring.scoreSettingsV2.method"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          900522568
                        )
                      }),
                      _vm._v(" "),
                      _vm.showRequestBody
                        ? [
                            _c("Field", {
                              attrs: {
                                label: _vm.$t("LABEL_CUSTOM_SCORING_BODY"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "LABEL_CUSTOM_SCORING_BODY_TT"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "customScoringBody",
                                          attrs: {
                                            rules: "required",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-10 col-sm-6"
                                                          },
                                                          [
                                                            _c("HttpBody", {
                                                              attrs: {
                                                                "has-macros": true,
                                                                "body-type":
                                                                  "json",
                                                                name:
                                                                  "customScoringBody",
                                                                "custom-class":
                                                                  "no-radius"
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.updateCustomScoringSettings
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .customScoring
                                                                    .scoreSettingsV2
                                                                    .body,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .customScoring
                                                                      .scoreSettingsV2,
                                                                    "body",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "customScoring.scoreSettingsV2.body"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            !_vm.isValidJson(
                                                              _vm.customScoring
                                                                .scoreSettingsV2
                                                                .body
                                                            )
                                                              ? _c("label", {
                                                                  directives: [
                                                                    {
                                                                      name: "t",
                                                                      rawName:
                                                                        "v-t",
                                                                      value:
                                                                        "ERROR_CUSTOM_SCORING_JSON",
                                                                      expression:
                                                                        "'ERROR_CUSTOM_SCORING_JSON'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "m-t-5 red"
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          directives: [
                                                            {
                                                              name: "t",
                                                              rawName: "v-t",
                                                              value: "REQUIRED",
                                                              expression:
                                                                "'REQUIRED'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "col-xs-2 col-sm-3 form-group__label-required"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3867717509
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2063277167
                              )
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("Field", {
                        attrs: {
                          label: _vm.$t("LABEL_CUSTOM_SCORING_HEADERS"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t(
                            "LABEL_CUSTOM_SCORING_HEADERS_TT"
                          )
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c("ValidationProvider", {
                                    ref: "customScoringHeaders",
                                    attrs: { slim: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ classes }) {
                                            return [
                                              _c("div", { class: classes }, [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-8 col-md-6"
                                                  },
                                                  [
                                                    _c("HttpHeaders", {
                                                      attrs: {
                                                        name:
                                                          "customScoringHeaders"
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.updateCustomScoringSettings
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.customScoring
                                                            .scoreSettingsV2
                                                            .headers,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.customScoring
                                                              .scoreSettingsV2,
                                                            "headers",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "customScoring.scoreSettingsV2.headers"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2477120268
                                    )
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1924945718
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row m-t-20" },
                        [
                          _vm.selectedMacros && _vm.selectedMacros.length
                            ? _c("CustomScoringSampleTokens", {
                                staticClass:
                                  "col-sm-offset-3 col-sm-8 col-md-6 m-b-15",
                                attrs: {
                                  "selected-macros": _vm.selectedMacros
                                },
                                on: {
                                  "update:selectedMacros": function($event) {
                                    _vm.selectedMacros = $event
                                  },
                                  "update:selected-macros": function($event) {
                                    _vm.selectedMacros = $event
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showInitialMessage && !_vm.isRequestLoading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-offset-3 col-sm-8 col-md-6"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bs-callout bs-callout-sm bs-callout-primary m-t-5"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MESSAGE_CUSTOM_SCORING_INITIAL"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row m-b-15" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-offset-3 col-sm-9" },
                          [
                            _vm.customScoringModified
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-danger m-r-10",
                                    attrs: { type: "button" },
                                    on: { click: _vm.revertChanges }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("REVERT")) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn",
                                attrs: {
                                  type: "button",
                                  disabled: !_vm.isRequestReady
                                },
                                on: { click: _vm.runRequest }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("BUTTON_RUN_REQUEST")) +
                                    "\n              "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-play",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isRequestLoading
                              ? _c("Loader", {
                                  attrs: { "custom-class": "size-sm m-l-5" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.requestSuccess && !_vm.isRequestLoading
                              ? _c("i", {
                                  staticClass:
                                    "fa fa-check text-success m-l-10",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.requestFail && !_vm.isRequestLoading
                              ? _c("i", {
                                  staticClass:
                                    "fa fa-warning text-danger m-l-10",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _vm.requestSuccess
                          ? _c(
                              "div",
                              {
                                staticClass: "col-sm-offset-3 col-sm-8 col-md-6"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bs-callout bs-callout-sm bs-callout-success m-t-5"
                                  },
                                  [
                                    _c("p", { staticClass: "m-b-10" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MESSAGE_CUSTOM_SCORING_SUCCESS"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "m-b-10 text-code" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.customScoring.scoreSettingsV2.method.toUpperCase()
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.completedCustomScoringRequestUrl
                                            )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.customScoring.scoreSettingsV2.method ===
                                    "post"
                                      ? _c("div", [
                                          _c("div", { staticClass: "m-b-10" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "LABEL_CUSTOM_SCORING_BODY"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "prism-editor-wrapper no-radius m-t-5 m-b-15 f-s-12"
                                            },
                                            [
                                              _c(
                                                "pre",
                                                { staticClass: "pre--basic" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.customScoringRequestBody
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "clickable text-underline m-b-10",
                                        on: { click: _vm.toggleResponse }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("LABEL_VIEW_RESPONSE")
                                            ) +
                                            "\n                "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-angle-right m-l-5",
                                          class: {
                                            "fa-rotate-90":
                                              _vm.showRequestResponse
                                          },
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "collapse",
                                      {
                                        model: {
                                          value: _vm.showRequestResponse,
                                          callback: function($$v) {
                                            _vm.showRequestResponse = $$v
                                          },
                                          expression: "showRequestResponse"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "prism-editor-wrapper no-radius m-t-10 f-s-12"
                                          },
                                          [
                                            _c(
                                              "pre",
                                              { staticClass: "pre--basic" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.customScoringRequestResponse
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.requestFail
                          ? _c(
                              "div",
                              {
                                staticClass: "col-sm-offset-3 col-sm-8 col-md-6"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bs-callout bs-callout-sm bs-callout-danger m-t-5"
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MESSAGE_CUSTOM_SCORING_FAILED"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.customScoringRequestError
                                      ? _c(
                                          "div",
                                          { staticClass: "m-t-10" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "clickable text-underline m-b-10",
                                                on: { click: _vm.toggleError }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t("LABEL_VIEW_ERROR")
                                                    ) +
                                                    "\n                  "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-angle-right m-l-5",
                                                  class: {
                                                    "fa-rotate-90":
                                                      _vm.showRequestError
                                                  },
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "collapse",
                                              {
                                                model: {
                                                  value: _vm.showRequestError,
                                                  callback: function($$v) {
                                                    _vm.showRequestError = $$v
                                                  },
                                                  expression: "showRequestError"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "prism-editor-wrapper no-radius m-t-10 f-s-12"
                                                  },
                                                  [
                                                    _c(
                                                      "pre",
                                                      {
                                                        staticClass:
                                                          "pre--basic"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.customScoringRequestError
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.showParsingSettings
                        ? [
                            _c("CustomScoringParsingSettings", {
                              attrs: {
                                "acceptance-parsing": _vm.acceptanceParsing,
                                "selected-score-parsing":
                                  _vm.selectedScoreParsing,
                                "custom-tags-selected": _vm.customTagsSelected,
                                "selectable-properties-config":
                                  _vm.selectablePropertiesConfig,
                                "custom-tags-config": _vm.customTagsConfig
                              },
                              on: {
                                "update:acceptanceParsing": function($event) {
                                  _vm.acceptanceParsing = $event
                                },
                                "update:acceptance-parsing": function($event) {
                                  _vm.acceptanceParsing = $event
                                },
                                "update:selectedScoreParsing": function(
                                  $event
                                ) {
                                  _vm.selectedScoreParsing = $event
                                },
                                "update:selected-score-parsing": function(
                                  $event
                                ) {
                                  _vm.selectedScoreParsing = $event
                                },
                                "update:customTagsSelected": function($event) {
                                  _vm.customTagsSelected = $event
                                },
                                "update:custom-tags-selected": function(
                                  $event
                                ) {
                                  _vm.customTagsSelected = $event
                                },
                                updateAcceptanceParsingSettings:
                                  _vm.updateCustomScoringSettings,
                                updateScoreParsingSettings:
                                  _vm.updateScoreParsingSettings,
                                addCustomTag: _vm.addCustomTag,
                                removeCustomTag: _vm.removeCustomTag
                              }
                            })
                          ]
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }